import React from 'react';
import AudioPlayer from './AudioPlayer';

const Stotras = () => {
  return (
    <section id="stotras" className="section bg-gradient-to-b from-blue-50 to-purple-50">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <h2 className="section-title text-center">
            Stotras and Bhajans
          </h2>

          {/* Combined Section with Image and Audio Players */}
          <div className="card-temple">
            {/* Deity Image */}
            <div className="mb-6">
              <img
                src="https://customer-assets.emergentagent.com/job_devaswom-preview/artifacts/msk50rx4_1000023657.jpg"
                alt="Lord Krishna deity"
                className="mx-auto max-w-full h-auto rounded-lg shadow-temple lotus-border"
              />
            </div>

            {/* Audio Player 1 */}
            <div className="mb-6">
              <AudioPlayer
                title="1. Ramaneeya Kshetra Sundara Mandira"
                src="https://customer-assets.emergentagent.com/job_devaswom-preview/artifacts/fb2fpfh2_mirthfulGuitar%20pedestals%20-%20temple.m4a"
              >
                {/* Composer credit under Bhajan 1 */}
                <p className="text-center text-gray-600 italic mt-4">Lyrics by Umesh T Bhat</p>
              </AudioPlayer>
            </div>

            {/* Audio Player 2 */}
            <div>
              <AudioPlayer
                title="2. Mahotsavaghoshu"
                src="https://customer-assets.emergentagent.com/job_devaswom-preview/artifacts/uxe8vqwa_bhajan1.MP3"
              >
                {/* Composer credit under Bhajan 2 */}
                <p className="text-center text-gray-600 italic mt-4">Lyrics by Umesh T Bhat</p>
                
                {/* Image under Bhajan 2 */}
                <div className="mt-6">
                  <img
                    src="https://customer-assets.emergentagent.com/job_ef1b1145-f8f0-4391-9cb1-5b2f821776b0/artifacts/u8a8cimb_DocScanner%20Mar%2015%2C%202026%2011-45%20AM-1%282040542183698185%29.jpg"
                    alt="Lord Krishna deity abhishekam"
                    className="mx-auto max-w-full h-auto rounded-lg shadow-lg"
                  />
                </div>
              </AudioPlayer>
            </div>

            {/* Audio Player 3 */}
            <div className="mt-6">
              <AudioPlayer
                title="3. Jagannathu Dwarakaraayu"
                src="https://customer-assets.emergentagent.com/job_ef1b1145-f8f0-4391-9cb1-5b2f821776b0/artifacts/yfjqni9q_krishna%20.mp3"
              >
              </AudioPlayer>
            </div>

            {/* Audio Player 4 */}
            <div className="mt-6">
              <AudioPlayer
                title="4. Jo Jo Rajagopala"
                src="https://customer-assets-m6fa6gv7.emergentagent.net/job_6b23d131-7c65-4566-a2b5-504887f6a0cf/artifacts/9tk7dlks_Iamastudent%20-%20Untitled%202026-07-22%2023_42-319%20%282%29.MP3"
              >
                <p className="text-center text-gray-600 italic mt-4">Lyrics - Rakesh R Prabhu, composed and sung by Pranav G Pai. Ragam - Ananda Bhairavi</p>
              </AudioPlayer>
            </div>

            {/* Audio Player 5 */}
            <div className="mt-6">
              <AudioPlayer
                title="5. Rajagopala Sree Krishna"
                src="https://customer-assets-m6fa6gv7.emergentagent.net/job_6b23d131-7c65-4566-a2b5-504887f6a0cf/artifacts/pozfhvjh_Rajagopala%20sree%20krishna-550%20%281%29.MP3"
              >
              </AudioPlayer>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Stotras;
